import React, { Component } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';


class Dashboard extends Component {
  render() {
    return (
      <Card>
        <CardHeader>
          <h1>Dashboard</h1>
        </CardHeader>
        <CardBody></CardBody>
      </Card>
    )
  }
}

export default Dashboard


// WEBPACK FOOTER //
// ./src/Pages/Admin/Dashboard.js